/// src/router/index.js

import { createRouter, createWebHashHistory } from "vue-router";
import LoginAIO from "../components/LoginAIO.vue";
import Dashboard from "../components/Dashboard.vue";
import AddSeller from "../components/AddSeller.vue";
import AddGroup from "../components/AddGroup.vue";
import SellersList from "../components/SellersList.vue";
import SellerLogin from "../components/SellerLogin.vue";
import SellerDashboard from "../components/SellerDashboard.vue";
import store from "../store";
import SellerGroupList from "../components/SellerGroupList.vue";
import GroupAdminLogin from "../components/GroupAdminLogin.vue";
import GroupAdminDashboard from "../components/GroupAdminDashboard.vue";
import AdminSellers from "../components/AdminSellers.vue";
import AdminLogin from "../components/AdminLogin.vue";
import AdminDashboard from "../components/AdminDashboard.vue";
import AdminSellerEdit from "../components/AdminSellerEdit.vue";
import TagsList from "../components/TagsList.vue";
import AddTag from "../components/AddTag.vue";
import TagGroupsList from "../components/TagGroupsList.vue";
import PartnersList from "../components/PartnersList.vue";
import AddPartner from "../components/AddPartner.vue";
import ConfigManager from "../components/ConfigManager.vue";
import PlaylistsCreate from "../components/PlaylistsCreate.vue";
import PlaylistsList from "../components/PlaylistsList.vue";
import AdminAdsContent from "../components/AdminAdsContent.vue";
import AdminAdsTxtManager from "@/components/AdminAdsTxtManager.vue";
import DeveloperApi from "../components/DeveloperApi/DeveloperApi.vue";
import DeveloperApiDoc from "../components/DeveloperApiDoc/DeveloperApiDoc.vue";
import TagsListChecker from "../components/TagsListChecker.vue";
import PartnerTagsList from "../components/PartnerTagsList.vue";
import PartnerAddTag from "../components/PartnerAddTag.vue";
import PodcastersList from "../components/PodcastersList.vue";
import AddPodcaster from "../components/AddPodcaster.vue";
import PodcasterDashboard from "../components/PodcasterDashboard.vue";
import PodcasterDashboardNew from "../components/podcaster_dashboard_new/PodcasterDashboardNew.vue";
import PodcastShowsList from "../components/PodcastShowsList.vue";
import AddPodcastShow from "../components/AddPodcastShow.vue";
import PodcasterEpisodesList from "../components/PodcasterEpisodesList.vue";
import PodcastAdminDashboard from "../components/PodcastAdminDashboard.vue";
import PodcastAdminShowsList from "../components/PodcastAdminShowsList.vue";
import AddPodcastAdminShow from "../components/AddPodcastAdminShow.vue";
import PodcastAdminEpisodesList from "../components/PodcastAdminEpisodesList.vue";
import PodcastAdminCampaignsList from "../components/PodcastAdminCampaignsList.vue";
import AddPodcastAdminCampaign from "../components/AddPodcastAdminCampaign.vue";
import PodcastAdminAlertRoom from "../components/PodcastAdminAlertRoom.vue";
import AdminPublisherOnboardingLinks from "@/components/AdminPublisherOnboardingLinks.vue";
import PublisherOnboard from "@/components/PublisherOnboard.vue";
import PodcasterOverview from "@/components/PodcasterOverview.vue";
import CustomReports from "@/components/CustomReports.vue";
import DemandAdstxtReport from "@/components/DemandAdstxtReport.vue";
import ContentPacksView from "../views/ContentPacksView.vue";
import AddContentPack from "@/components/AddContentPack.vue";
import ArgusSnapshot from "@/components/ArgusSnapshot.vue";
import AdminNewDashboard from "@/components/AdminNewDashboard/AdminNewDashboard.vue";
import AdminManagementDashboard from "@/components/ManagementDashboard/AdminManagementDashboard.vue";
import ScheduledReports from "@/components/ScheduledReports.vue";
import AddScheduledReport from "@/components/AddScheduledReport.vue";
import PodcastAdminCampaignsBulkChange from "@/components/PodcastAdminCampaignsBulkChange.vue";
import PodcastAdminShowsBulkChange from "@/components/PodcastAdminShowsBulkChange.vue";

import NetworkAdminDashboard from "@/components/NetworkDashboard/NetworkAdminDashboard.vue";
import OnboardingWizard from "@/components/OnboardingWizard/OnboardingWizard.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginAIO,
  },
  {
    path: "/publisher-onboard",
    name: "PublisherOnboard",
    component: PublisherOnboard,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/add-seller",
    name: "AddSeller",
    component: AddSeller,
  },
  {
    path: "/add-seller/:sellerId",
    name: "UpdateSeller",
    component: AddSeller,
  },
  {
    path: "/sellers",
    name: "SellersList",
    component: SellersList,
  },
  {
    path: "/groups",
    name: "GroupsList",
    component: SellerGroupList,
  },
  {
    path: "/add-seller-group",
    name: "AddSellerGroup",
    component: AddGroup,
  },
  {
    path: "/add-seller-group/:groupId",
    name: "UpdateSellerGroup",
    component: AddGroup,
  },
  { path: "/tags", name: "PartnerTagsList", component: PartnerTagsList },
  { path: "/add-tag", name: "PartnerAddTag", component: PartnerAddTag },
  {
    path: "/update-tag/:tagId",
    name: "PartnerUpdateTag",
    component: PartnerAddTag,
  },
  {
    path: "/publisher-onboarding-links",
    name: "PublisherOnboardingLinks",
    component: AdminPublisherOnboardingLinks,
  },
  {
    path: "/seller-dashboard/:sellerId",
    name: "PartnerSellerDashboard",
    component: SellerDashboard,
  },
  {
    path: "/group-admin/seller-dashboard/:sellerId",
    name: "GroupAdminSellerDashboard",
    component: SellerDashboard,
  },
  {
    path: "/group-dashboard/:sellerGroupId",
    name: "PartnerGroupDashboard",
    component: GroupAdminDashboard,
  },
  {
    path: "/admin/group-dashboard/:sellerGroupId",
    name: "AdminGroupDashboard",
    component: GroupAdminDashboard,
  },
  {
    path: "/seller/login",
    name: "SellerLogin",
    component: SellerLogin,
  },
  {
    path: "/seller/dashboard",
    name: "SellerDashboard",
    component: SellerDashboard,
  },
  {
    path: "/group-admin/login",
    name: "GroupAdminLogin",
    component: GroupAdminLogin,
  },
  {
    path: "/group-admin/dashboard",
    name: "GroupAdminDashboard",
    component: GroupAdminDashboard,
  },
  {
    path: "/group-admin/sellers/",
    name: "GroupAdminSellersList",
    component: SellersList,
  },
  {
    path: "/group-admin/add-seller",
    name: "GroupAdminAddSeller",
    component: AddSeller,
  },
  {
    path: "/group-admin/add-seller/:sellerId",
    name: "GroupAdminUpdateSeller",
    component: AddSeller,
  },
  {
    path: "/admin/sellers",
    name: "AdminSellers",
    component: AdminSellers,
  },
  {
    path: "/admin/sellers/edit",
    name: "AdminSellerEdit",
    component: AdminSellerEdit,
    props: (route) => ({
      sellerid: route.query.sellerid,
      partnerid: route.query.partnerid,
      tagbl: route.query.tags_bl,
      tagwl: route.query.tags_wl,
    }),
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: AdminLogin,
  },
  {
    path: "/admin/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
  },
  {
    path: "/admin/dashboard-new",
    name: "AdminNewDashboard",
    component: AdminNewDashboard,
  },
  {
    path: "/admin/management-dashboard",
    name: "AdminManagement",
    component: AdminManagementDashboard,
  },
  { path: "/admin/tags", name: "TagsList", component: TagsList },
  { path: "/admin/add-tag", name: "AddTag", component: AddTag },
  { path: "/admin/update-tag/:tagId", name: "UpdateTag", component: AddTag },
  {
    path: "/admin/tag-groups",
    name: "TagGroupsList",
    component: TagGroupsList,
  },
  {
    path: "/admin/partners",
    name: "PartnersList",
    component: PartnersList,
  },
  {
    path: "/admin/add-partner",
    name: "AddPartner",
    component: AddPartner,
  },
  {
    path: "/admin/config-manager",
    name: "ConfigManager",
    component: ConfigManager,
    props: (route) => ({
      sellerid: route.query.sellerid,
      partnerid: route.query.partnerid,
    }),
  },
  {
    path: "/admin/add-partner/:partnerId",
    name: "UpdatePartner",
    component: AddPartner,
  },
  {
    path: "/admin/partner-dashboard/:partnerId",
    name: "AdminPartnerDashboard",
    component: Dashboard,
  },
  {
    path: "/admin/ads-txt",
    name: "AdsTxt",
    component: AdminAdsContent,
  },
  {
    path: "/admin/ads-txt-manager",
    name: "AdsTxtManager",
    component: AdminAdsTxtManager,
  },
  {
    path: "/admin/tags-list-checker",
    name: "TagsListChecker",
    component: TagsListChecker,
  },
  {
    path: "/admin/add-seller-group/:groupId",
    name: "AdminUpdateSellerGroup",
    component: AddGroup,
  },
  {
    path: "/admin/groups",
    name: "AdminGroupsList",
    component: SellerGroupList,
  },
  {
    path: "/admin/onboarding",
    name: "OnboardingWizard",
    component: OnboardingWizard,
  },
  {
    path: "/admin/add-seller",
    name: "AdminAddSeller",
    component: AddSeller,
  },
  {
    path: "/admin/publisher-onboarding-links",
    name: "AdminPublisherOnboardingLinks",
    component: AdminPublisherOnboardingLinks,
  },
  {
    path: "/admin/add-seller/:sellerId",
    name: "AdminUpdateSeller",
    component: AddSeller,
  },
  {
    path: "/admin/scheduled-reports",
    name: "AdminReportSchedules",
    component: ScheduledReports,
  },
  {
    path: "/admin/add-scheduled-report",
    name: "AdminAddScheduledReport",
    component: AddScheduledReport,
  },
  {
    path: "/playlists/create",
    name: "PlaylistCreate",
    component: PlaylistsCreate,
  },
  {
    path: "/playlists",
    name: "PlaylistsList",
    component: PlaylistsList,
  },
  {
    path: "/developers",
    name: "DeveloperAPI",
    component: DeveloperApi,
  },
  {
    path: "/developers/doc",
    name: "DeveloperAPIDoc",
    component: DeveloperApiDoc,
  },
  {
    path: "/group-admin/developers",
    name: "GroupAdminDeveloperAPI",
    component: DeveloperApi,
  },
  {
    path: "/group-admin/developers/doc",
    name: "GroupAdminDeveloperAPIDoc",
    component: DeveloperApiDoc,
  },
  {
    path: "/podcaster/dashboard-old",
    name: "PodcasterDashboard",
    component: PodcasterDashboard,
  },
  {
    path: "/podcaster/dashboard",
    name: "PodcasterDashboardNew",
    component: PodcasterDashboardNew,
  },
  {
    path: "/podcaster/shows",
    name: "PodcastShowsList",
    component: PodcastShowsList,
  },

  {
    path: "/podcaster/episodes",
    name: "PodcasterEpisodesList",
    component: PodcasterEpisodesList,
  },
  {
    path: "/podcaster/referrals",
    name: "PodcasterReferralsList",
    component: PodcasterReferralsList,
  },
  {
    path: "/podcast-admin/dashboard-old",
    name: "PodcastAdminDashboard",
    component: PodcastAdminDashboard,
  },
  {
    path: "/podcast-admin/dashboard",
    name: "PodcastAdminDashboardNew",
    component: PodcastAdminDashboardNew,
  },
  {
    path: "/podcast-admin/shows",
    name: "PodcastAdminShowsList",
    component: PodcastAdminShowsList,
    props: true,
  },
  {
    path: "/podcast-admin/add-show",
    name: "AddPodcastAdminShow",
    component: AddPodcastAdminShow,
  },
  {
    path: "/podcast-admin/add-show/:showId",
    name: "UpdatePodcastAdminShow",
    component: AddPodcastAdminShow,
  },
  {
    path: "/podcaster/add-show",
    name: "AddPodcastShow",
    component: AddPodcastShow,
  },
  {
    path: "/podcaster/add-show/:showId",
    name: "UpdatePodcastShow",
    component: AddPodcastShow,
  },

  {
    path: "/podcast-admin/episodes",
    name: "PodcastAdminEpisodesList",
    component: PodcastAdminEpisodesList,
  },
  {
    path: "/podcast-admin/podcasters",
    name: "PodcastersList",
    component: PodcastersList,
  },
  {
    path: "/podcast-admin/gifts",
    name: "Gifts",
    component: Gifts,
  },
  {
    path: "/podcast-admin/add-podcaster",
    name: "AddPodcaster",
    component: AddPodcaster,
  },
  {
    path: "/podcast-admin/add-podcaster/:podcasterId",
    name: "UpdatePodcaster",
    component: AddPodcaster,
  },
  {
    path: "/podcast-admin/podcaster-overview/:podcasterId",
    name: "PodcasterOverview",
    component: PodcasterOverview,
  },
  {
    path: "/podcast-admin/campaigns",
    name: "PodcastAdminCampaignsList",
    component: PodcastAdminCampaignsList,
  },
  {
    path: "/podcast-admin/add-campaign",
    name: "AddPodcastAdminCampaign",
    component: AddPodcastAdminCampaign,
  },
  {
    path: "/podcast-admin/bulk-change-campaign",
    name: "PodcastAdminCampaignBulkChange",
    component: PodcastAdminCampaignsBulkChange,
  },
  {
    path: "/podcast-admin/bulk-change-show",
    name: "PodcastAdminShowBulkChange",
    component: PodcastAdminShowsBulkChange,
  },
  {
    path: "/podcast-admin/add-campaign/:campaignId",
    name: "UpdatePodcastAdminCampaign",
    component: AddPodcastAdminCampaign,
    props: (route) => ({
      is_duplicate: route.query.is_duplicate,
    }),
  },
  {
    path: "/podcast-admin/alert-room",
    name: "PodcastAdminAlertRoom",
    component: PodcastAdminAlertRoom,
  },
  {
    path: "/podcast-admin/podcaster-dashboard",
    name: "PodcastAdminPodcasterDashboard",
    component: PodcasterDashboard,
    props: (route) => ({
      podcasterId: route.query.podcasterId,
      connectedPublisherId: route.query.connectedPublisherId,
      plan: route.query.plan,
    }),
  },
  {
    path: "/podcast-admin/stats-reports",
    name: "PodcastAdminStatsReports",
    component: () => import("@/components/PodcastStatsReports.vue"),
  },
  {
    path: "/podcast-admin/accounting",
    name: "PodcastAdminAccounting",
    component: () => import("@/components/PodcasterAccountingPage.vue"),
  },
  {
    path: "/admin/custom-reports",
    name: "CustomReports",
    component: CustomReports,
  },
  {
    path: "/admin/demand-adstxt-report",
    name: "DemandAdstxtReport",
    component: DemandAdstxtReport,
  },
  {
    path: "/admin/content-packs",
    name: "ContentPacks",
    component: ContentPacksView,
  },
  {
    path: "/admin/group-account-managers",
    name: "GroupAccountManagers",
    component: GroupAccountManagers,
  },
  {
    path: "/admin/content-packs/add",
    name: "AddContentPack",
    component: AddContentPack,
  },
  {
    path: "/admin/content-packs/edit/:id",
    name: "EditContentPack",
    component: AddContentPack,
  },
  {
    path: "/admin/argus-snapshot",
    name: "ArgusSnapshot",
    component: ArgusSnapshot,
  },
  {
    path: "/podcast-admin/podcast-generation",
    name: "PodcastGenerationList",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationList.vue"),
  },
  {
    path: "/podcast-admin/podcast-generation/new",
    name: "AddPodcastGeneration",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationWizard.vue"),
  },
  {
    path: "/podcast-admin/podcast-generation/:taskId/edit",
    name: "EditPodcastGeneration",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationWizard.vue"),
  },
  {
    path: "/podcast-admin/avatars",
    name: "Avatars",
    component: () => import("@/components/AvatarsList.vue"),
  },
  {
    path: "/podcast-admin/avatars/add",
    name: "AddAvatar",
    component: () => import("@/components/AvatarForm.vue"),
  },
  {
    path: "/podcast-admin/avatars/edit/:avatarId",
    name: "EditAvatar",
    component: () => import("@/components/AvatarForm.vue"),
  },
  {
    path: "/podcast-admin/music-studio",
    name: "MusicStudio",
    component: () => import("@/components/PodcastGeneration/MusicStudio.vue"),
  },
  {
    path: "/podcast-admin/music-studio/add",
    name: "AddMusic",
    component: () => import("@/components/PodcastGeneration/MusicForm.vue"),
  },
  {
    path: "/podcast-admin/custom-reports",
    name: "PodcastAdminCustomReports",
    component: () => import("@/components/PodcastCustomReports.vue"),
  },
  {
    path: "/podcast-admin/podcast-generation/:taskId/assets",
    name: "TaskAssets",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationAssets.vue"),
  },
  {
    path: "/network-admin/dashboard",
    name: "NetworkAdminDashboard",
    component: NetworkAdminDashboard,
  },
  {
    path: "/auxigen/podcast-generation",
    name: "AuxigenPodcastGenerationList",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationList.vue"),
  },
  {
    path: "/auxigen/podcast-generation/new",
    name: "AuxigenAddPodcastGeneration",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationWizard.vue"),
  },
  {
    path: "/auxigen/podcast-generation/:taskId/edit",
    name: "AuxigenEditPodcastGeneration",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationWizard.vue"),
  },
  {
    path: "/auxigen/podcast-generation/:taskId/assets",
    name: "AuxigenTaskAssets",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationAssets.vue"),
  },
  {
    path: "/public/podcast-generation/:taskId/assets",
    name: "TaskAssetsPublic",
    component: () =>
      import("@/components/PodcastGeneration/PodcastGenerationAssets.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "/admin/accounting",
    name: "AdminAccounting",
    component: () => import("@/components/PublisherAccountingPage.vue"),
  },
  {
    path: "/podcaster-join",
    name: "PodcasterJoin",
    component: () =>
      import("@/components/podcaster-dashboard/PodcasterJoin.vue"),
  },
  {
    path: "/podcaster-join/banking",
    name: "PodcasterBanking",
    component: () =>
      import("@/components/podcaster-dashboard/PodcasterBanking.vue"),
  },
  {
    path: "/podcast-admin/networks",
    name: "PodcastNetworksList",
    component: () => import("@/components/PodcastNetworksList.vue"),
  },
  {
    path: "/podcast-admin/add-network",
    name: "AddPodcastNetwork",
    component: () => import("@/components/AddPodcastNetwork.vue"),
  },
  {
    path: "/podcast-admin/add-network/:networkId",
    name: "UpdatePodcastNetwork",
    component: () => import("@/components/AddPodcastNetwork.vue"),
  },
  {
    path: "/podcast-admin/hosting-seats",
    name: "HostingPlatformSeatsList",
    component: () => import("@/components/HostingPlatformSeatsList.vue"),
  },
  {
    path: "/podcast-admin/add-hosting-seat",
    name: "AddHostingPlatformSeat",
    component: () => import("@/components/AddHostingPlatformSeat.vue"),
  },
  {
    path: "/podcast-admin/add-hosting-seat/:seatId",
    name: "UpdateHostingPlatformSeat",
    component: () => import("@/components/AddHostingPlatformSeat.vue"),
  },
  {
    path: "/podcast-admin/hosting-validation-notifications",
    name: "HostingValidationNotifications",
    component: () => import("@/components/HostingValidationNotifications.vue"),
  },
  {
    path: "/podcast-admin/stats-validation-notifications",
    name: "StatsValidationNotifications",
    component: () => import("@/components/StatsValidationNotifications.vue"),
  },
  {
    path: "/podcast-admin/hosting-seats/:seatId/manage",
    name: "ManageHostingSeat",
    component: () => import("@/components/HostingSeatManagement.vue"),
  },
  {
    path: "/podcast-admin/hosting-performance",
    name: "HostingSeatPerformanceTracking",
    component: () => import("@/components/HostingSeatPerformanceTracking.vue"),
  },
  {
    path: "/podcast-admin/hosting-performance/set-targets",
    name: "HostingSeatPerformanceSetTargets",
    component: () =>
      import("@/components/HostingSeatPerformanceTrackingSetTargets.vue"),
  },
  {
    path: "/podcast-admin/auxigen-dashboard",
    name: "AuxigenDashboard",
    component: () => import("@/components/AuxigenDashboard.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

import jwt_decode from "jwt-decode";
import GroupAccountManagers from "@/components/GroupAccountManagers.vue";
import { limitedAdminPages } from "@/consts";
import PodcastAdminDashboardNew from "@/components/podcastadmin_dashboard_new/PodcastAdminDashboardNew.vue";
import Gifts from "@/components/Gifts.vue";
import PodcasterReferralsList from "@/components/PodcasterReferralsList.vue";

router.beforeEach((to, from, next) => {
  try {
    console.log(to.matched);
    if (to.matched.some((record) => record.meta.public)) {
      // Public route, allow access without authentication
      return next();
    }

    const seller = JSON.parse(localStorage.getItem("seller"));
    store.commit("setSeller", seller);

    const partner = JSON.parse(localStorage.getItem("partner"));
    store.commit("setPartner", partner);

    const groupAdmin = JSON.parse(localStorage.getItem("groupAdmin"));
    store.commit("setGroupAdmin", groupAdmin);

    const admin = JSON.parse(localStorage.getItem("admin"));
    store.commit("setAdmin", admin);

    const podcaster = JSON.parse(localStorage.getItem("podcaster"));
    store.commit("setPodcaster", podcaster);

    const podcastAdmin = JSON.parse(localStorage.getItem("podcastAdmin"));
    store.commit("setPodcastAdmin", podcastAdmin);

    // ___ Network Admin ___
    const networkAdmin = JSON.parse(localStorage.getItem("networkAdmin"));
    store.commit("setNetworkAdmin", networkAdmin);

    const auxigen = JSON.parse(localStorage.getItem("auxigen"));
    store.commit("setAuxigen", auxigen);
  } catch (error) {
    console.log(error);
  }

  if (to.fullPath.includes("/seller/")) {
    sellerLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/admin/")) {
    adminLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/group-admin/")) {
    groupAdminLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/podcaster/")) {
    podcasterLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/podcast-admin/")) {
    podcastAdminLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/network-admin/")) {
    networkAdminLoginValidation(to, from, next);
  } else if (to.fullPath.includes("/auxigen/")) {
    auxigenLoginValidation(to, from, next);
  } else {
    partnerLoginValidation(to, from, next);
  }
});

// Navigation guard to handle redirects after login
router.afterEach((to, from) => {
  // Clear stored redirect after navigation to avoid issues
  if (
    to.name === "Login" ||
    to.name === "SellerLogin" ||
    to.name === "AdminLogin" ||
    to.name === "GroupAdminLogin"
  ) {
    // Don't clear redirect when going to login pages
    return;
  }
  // Clear redirect after successful navigation to any other page
  sessionStorage.removeItem("redirectAfterLogin");
});

function adminLoginValidation(to, from, next) {
  const token = localStorage.getItem("adminToken");
  const adminUserData = JSON.parse(localStorage.getItem("admin"));

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setAdminLoggedIn", true);
      } else {
        store.commit("setAdminLoggedIn", false);
        localStorage.removeItem("adminToken");
      }
    } catch (error) {
      store.commit("setAdminLoggedIn", false);
      localStorage.removeItem("adminToken");
    }
  }

  if (
    !store.state.isAdminLoggedIn ||
    (adminUserData?.isLimitedAdmin && !limitedAdminPages.includes(to.name))
  ) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function partnerLoginValidation(to, from, next) {
  const token = localStorage.getItem("token");

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setLoggedIn", true);
        store.commit("setPartnerId", decoded.partner_id);
      } else {
        store.commit("setLoggedIn", false);
        localStorage.removeItem("token");
      }
    } catch (error) {
      store.commit("setLoggedIn", false);
      localStorage.removeItem("token");
    }
  }

  if (
    ![
      "Login",
      "PublisherOnboard",
      "PodcasterJoin",
      "PodcasterBanking",
    ].includes(to.name) &&
    !store.state.isLoggedIn
  ) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function groupAdminLoginValidation(to, from, next) {
  const token = localStorage.getItem("groupAdminToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setGroupAdminLoggedIn", true);
      } else {
        store.commit("setGroupAdminLoggedIn", false);
        localStorage.removeItem("groupAdminToken");
      }
    } catch (error) {
      store.commit("setGroupAdminLoggedIn", false);
      localStorage.removeItem("groupAdminToken");
    }
  }

  if (!store.state.isGroupAdminLoggedIn) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function podcasterLoginValidation(to, from, next) {
  const token = localStorage.getItem("podcasterToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setPodcasterLoggedIn", true);
      } else {
        store.commit("setPodcasterLoggedIn", false);
        localStorage.removeItem("podcasterToken");
      }
    } catch (error) {
      store.commit("setPodcasterLoggedIn", false);
      localStorage.removeItem("podcasterToken");
    }
  }

  if (!store.state.isPodcasterLoggedIn) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function podcastAdminLoginValidation(to, from, next) {
  const token = localStorage.getItem("podcastAdminToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setPodcastAdminLoggedIn", true);
      } else {
        store.commit("setPodcastAdminLoggedIn", false);
        localStorage.removeItem("podcastAdminToken");
      }
    } catch (error) {
      store.commit("setPodcastAdminLoggedIn", false);
      localStorage.removeItem("podcastAdminToken");
    }
  }

  if (!store.state.isPodcastAdminLoggedIn) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function sellerLoginValidation(to, from, next) {
  const token = localStorage.getItem("sellerToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);

      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setSellerLoggedIn", true);
        store.commit("setSellerId", decoded.seller_id);
        store.commit("setSellerPartnerId", decoded.partner_id);
      } else {
        store.commit("setSellerLoggedIn", false);
        localStorage.removeItem("sellerToken");
      }
    } catch (error) {
      store.commit("setSellerLoggedIn", false);
      localStorage.removeItem("sellerToken");
    }
  }

  if (!store.state.isSellerLoggedIn) {
    // Store the intended destination
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

// ___ Network Admin ___
function networkAdminLoginValidation(to, from, next) {
  const token = localStorage.getItem("networkAdminToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);
      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setNetworkAdminLoggedIn", true);
      } else {
        store.commit("setNetworkAdminLoggedIn", false);
        localStorage.removeItem("networkAdminToken");
      }
    } catch (error) {
      store.commit("setNetworkAdminLoggedIn", false);
      localStorage.removeItem("networkAdminToken");
    }
  }

  if (!store.state.isNetworkAdminLoggedIn) {
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

function auxigenLoginValidation(to, from, next) {
  const token = localStorage.getItem("auxigenToken");

  if (token) {
    try {
      const decoded = jwt_decode(token);
      if (decoded.exp * 1000 > Date.now()) {
        store.commit("setAuxigenLoggedIn", true);
      } else {
        store.commit("setAuxigenLoggedIn", false);
        localStorage.removeItem("auxigenToken");
      }
    } catch (error) {
      store.commit("setAuxigenLoggedIn", false);
      localStorage.removeItem("auxigenToken");
    }
  }

  if (!store.state.isAuxigenLoggedIn) {
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: "Login" });
  } else {
    next();
  }
}

export default router;
